
import React, { useState, useMemo } from "react";
import CTable from "components/common/Table";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import MenuItem from "components/common/MenuItem";
import Paper from "components/common/Paper";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import { Switch, Typography } from "@mui/material";
import Button from "components/common/Button";
import Chip from "@mui/material/Chip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Link from "components/common/Link";
// import { useHistory } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SearchBar from "components/common/SearchBar";


const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "#19AA69",
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}));
const Faq = ({
  data,
  category,
  handleClickOpen,
  handleDeleteClickOpen,
  handelChangeFilter,
  ParentCategoriesList,
  isloadingFaqTable,
  handleEditClick,
  handleDeleteFaqDailogOpen,
  searchhandleChange,
  selectedVal
}) => {

  // const [inputText, setInputText] = useState("");

 
  const handleCategoryChange = (e) => {
    console.log('first', e)
    handelChangeFilter(e);
    // setInputText("");
  };
  // let inputSearchHandler = (e) => {
  //   const lowerCase = e.toLowerCase();
  //   setInputText(lowerCase);
  // };
  let pageTypes = [
    {
      name: "Ev Website",
      id: "EVJOINTS_WEBSITE"
    },
    {
      name: "Ev APP",
      id: "EVJOINTS_APP"
    },
    {
      name: "Home Page",
      id: "HOME_PAGE"
    },
    {
      name: "Trip Planner",
      id: "TRIP_PLAN"
    },
  ]
  const classes = useStyles();
  // let history = useHistory();
  const columns = [
    {
      field: "question",
      headerName: "Question",
    },
    {
      field: "answer",
      headerName: "Answer",
      //ellipsis: true, and on hover show full text
      valueGetter: (v, d) => {
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Grid item xs={12}>
                  <LightTooltip
                    title={v}
                    placement="top"
                    sx={{
                      backgroundColor: "white",
                      color: "green",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        width: "200px",
                        letterSpacing: "0.00938em",
                        textAlign: "left",
                        padding: "0px 10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {v}
                    </Typography>
                  </LightTooltip>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },
    {
      field: "category",
      headerName: "Category",
      valueGetter: (v, d) => {
        return (
          <>
            <Box sx={{ height: "10px" }}>
              <Typography
                variant="contained"
                color="primary"
                sx={{
                  fontSize: "12px",
                  borderRadius: "20px",
                  fontWeight: "600",
                }}
              >
                {d?.faq_category?.name}
              </Typography>
            </Box>
          </>
        );
      },
    },

    {
      field: "category",
      headerName: "Sub Category",
      valueGetter: (v, d) => {
        return (
          <>
            <Grid container spacing={0}>
              <Box sx={{ height: "10px" }}>
                {d?.faq_subcategory?.name && (
                  <Typography
                    variant="contained"
                    color="primary"
                    sx={{
                      fontSize: "12px",
                      borderRadius: "20px",
                      fontWeight: "600",
                    }}
                  >
                    {d?.faq_subcategory?.name}
                  </Typography>
                )}
              </Box>
            </Grid>
          </>
        );
      },
    },

    {
      field: "Action",
      headerName: "Keywords",
      valueGetter: (v, d) => {
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Grid item lg={12} md={12}>
                  <Tooltip
                    title="View Keywords"
                    placement="top"
                    sx={{
                      backgroundColor: "white",
                      color: "green",
                    }}
                  >
                    <InfoIcon
                      onClick={() => handleClickOpen(d.id)}
                      sx={{
                        cursor: "pointer",
                        color: "#19AA69",
                        width: "24px !important",
                        marginRight: "5px",
                      }}
                    />
                  </Tooltip>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },

    {
      field: "Action",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            <Grid container spacing={0}>
              <Stack direction="row" spacing={0}>
                <Grid item lg={12} md={12} sx={{ width: "8rem" }}>
                  <Tooltip
                    title="Update"
                    placement="top"
                    sx={{
                      backgroundColor: "white",
                      color: "green",
                    }}
                  >
                    <EditOutlinedIcon
                      sx={{
                        cursor: "pointer",
                        color: "#19AA69",
                        marginRight: "5px",
                        fontSize: "25px",
                      }}
                      onClick={() => {
                        handleEditClick(d.id)
                      }}
                    />
                  </Tooltip>

                  <Tooltip
                    title="Enable-Disable"
                    placement="top"
                    sx={{
                      backgroundColor: "white",
                      color: "green",
                    }}
                  >
                    <Switch
                      checked={d.status === 1 ? true : false}
                      onClick={() =>
                        handleDeleteClickOpen(d.id, d.status ? 0 : 1)
                      }
                      sx={{
                        cursor: "pointer",
                        color: "#19AA69",
                        marginTop: "-18px",
                      }}
                    />
                  </Tooltip>

                  
                  <Tooltip
                    title="Delete"
                    placement="top"
                    sx={{
                      backgroundColor: "white",
                      color: "green",
                    }}
                  >
                    <DeleteOutlineOutlinedIcon
                    
                      onClick={() =>
                        handleDeleteFaqDailogOpen(d.id)
                      }
                      sx={{
                        cursor: "pointer",
                        color: "red",
                        marginTop: "-18px",
                      }}
                    />
                  </Tooltip>
                </Grid>
              </Stack>
            </Grid>
          </>
        );
      },
    },
  ];
  return (
    <Box
      className={classes.center}
      sx={{ marginTop: "1.6rem", width: "100% " }}
    >
      <Card>
        <CardContent>
          {/* <Link to="/query" style={{ textDecoration: "none" }}> */}
            <Text
              variant="h5"
              color="#707070"
              sx={{
                fontSize: "24px",
                marginBottom: "25px",
              }}
            >
              FAQ  
            </Text>
          {/* </Link> */}
          <Grid>
            <Box className={classes.category_box}>
              <Link to="/faq/category" style={{ textDecoration: "none" }}>
                <Chip
                  className={classes.category_heading}
                  label="FAQ CATEGORIES"
                />
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to="faq/add"
              >
                <Button
                  className={classes.category_btn}
                  variant="contained"
                  color="primary"
                >
                  Add New
                </Button>
              </Link>
            </Box>
          </Grid>
          <Stack
            direction={{ sm: "column", xs: "column", md: "row" }}
            spacing={2}
            justifyContent="space-between"
            sx={{
              marginBottom: "20px",
              height: "3.5rem",
              marginTop: "3rem",
            }}
          >
            <Stack
              direction={{ sm: "column", xs: "column", md: "row" }}
              spacing={1}
              justifyContent="space-between"
              sx={{
                width: "100%",
                height: "3.5rem",
              }}
            >
              <Stack
                direction={{ sm: "column", xs: "column", md: "row" }}
                spacing={1}
              >
                <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                      Select Page Type
                    </InputLabel>
                    <Select
                      sx={{ fontSize: "14px" }}
                      labelId="category-label"
                      label="Select Page Type"
                      name={"content_type"}
                      className={classes.table_location}
                      onChange={(e) => {
                        handleCategoryChange(e);
                      }}
                      defaultValue={"all"}
                    >
                      <MenuItem sx={{ fontSize: "14px" }} key="all" value="all">
                        All
                      </MenuItem>

                      {pageTypes?.map((ven) => (
                        <MenuItem
                          sx={{ fontSize: "14px" }}
                          key={ven.name}
                          value={ven.id}
                        >
                          {ven.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                      Category 
                    </InputLabel>
                    <Select
                      sx={{ fontSize: "14px" }}
                      labelId="category-label"
                      label="category"
                      name="category_id"
                      className={classes.table_location}
                      onChange={(e) => {
                        handleCategoryChange(e);
                      }}
                      defaultValue={"all"}
                      value={selectedVal?.category_id ?? "all"}
                    >
                      <MenuItem sx={{ fontSize: "14px" }} key="all" value="all">
                        All
                      </MenuItem>

                      {ParentCategoriesList?.map((ven) => (
                        <MenuItem
                          sx={{ fontSize: "14px" }}
                          key={ven.name}
                          value={ven.id}
                        >
                          {ven.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {category && category.length > 0 ? (
                  <Box sx={{ maxWidth: 143, minWidth: 143 }}>
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                        Sub Category
                      </InputLabel>
                      <Select
                        sx={{ fontSize: "14px" }}
                        labelId="subcategory-label"
                        label="subcategory"
                        name="subcategory_id"
                        value={selectedVal?.subcategory_id ?? "all"}
                        className={classes.table_location}
                        onChange={(e) => {
                          handleCategoryChange(e);
                        }}
                        defaultValue={"all"}
                      >
                        <MenuItem
                          sx={{ fontSize: "14px" }}
                          key="all"
                          value="all"
                        >
                          All
                        </MenuItem>
                        {category?.map((ven) => (
                          <MenuItem
                            sx={{ fontSize: "14px" }}
                            key={ven.name}
                            value={ven.id}
                          >
                            {ven.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                ) : null}
              </Stack>
              <Box>
                <Box className={classes.searchBox}>
                <SearchBar
                    onSearchChange={(value) =>
                      searchhandleChange("inputsearch", value)
                    }
                  />
                </Box>
              </Box>
            </Stack>
          </Stack>

          <Box className={classes.table}>
            <CTable
              isLoading={isloadingFaqTable}
              columns={columns}
              data={data}
              pagination={true}
              localPagination={true}
              page={0}
              rowsPerPage={5}
            ></CTable>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  table: {
    "@media (max-width:768px)": {
      marginTop: "60%",
    },
  },

  table_location: {
    "@media (max-width:768px)": {
      width: "235%",
      "@media (max-width:768px)": {
        width: "215%",
      },
    },
  },
  searchBox: {
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    "@media (max-width:768px)": {
      float: "none",
    },
  },
  category_box: {
    float: "right",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginTop: "-50px",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  category_heading: {
    cursor: "pointer",
    marginTop: "12 px",
    alignItems: "center",
    padding: "0 8px",
    backgroundColor: "unset !important ",
    color: "#19AA69",
    border: "1px solid #19AA69",
    marginRight: "20px",
    "@media (max-width:768px)": {
      marginTop: "16px",
    },
  },
  category_btn: {
    height: "32px",
    fontSize: "14px",
    border: "1px solid #19AA69",
    borderRadius: "20px",
    "@media (max-width:768px)": {
      marginTop: "12px",
    },
  },
}));
export default Faq;
